import React from 'react';
import PropTypes from 'prop-types';
import {
  ExploreMetricsPage,
} from '@avtechsoftware/react-component-library/src/components/metrics/ExploreMetricsPage/ExploreMetricsPage';
import AvtechApplicationCodes from '@avtechsoftware/ra-javascript-utilities/src/types/AvtechApplicationCodes';
import { withRouter } from 'react-router-dom';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { connect } from 'react-redux';
import {
  fetchDeviceListData,
  selectByUuidOrMacAddress,
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../redux/slices/deviceList/deviceListSlice';
import {
  selectActiveAlertEventList,
  selectActiveAlertEventsForAlertId,
} from '../../../redux/slices/alertEvents/alertEventsSlice';
import {
  dismissAllMessages,
  dismissMessage,
  pushSessionMessage,
  selectAllToastNotifications,
} from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import {
  selectAllThresholdRanges,
  selectThresholdRangeById,
} from '../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import {
  selectActiveSubscriptionCounts,
  selectSessionInformation,
  sessionInformationPropType,
} from '../../../redux/slices/sessionSlice';
import { deviceListContextPropType } from '../../../contexts/DeviceListContextPropTypes/DeviceListContextPropTypes';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import { sessionHash } from '../../../utility/remoteServiceUtil';
import envConfig from '../../../envConfig';
import MaxReportsBanner from '../../layout/MaxReportsBanner/MaxReportsBanner';
import { getAnalogComputedUnit } from '../../../redux/slices/deviceList/deviceListHelperUtils';
import {
  getMetricsGroupContextRedux,
  selectAllMetricsGroups,
  selectMetricGroupById,
} from '../../../redux/slices/metricsGroupSlice/metricsGroupSlice';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';
import { store } from '../../../redux/store';

class ExploreMetricsPageConnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertList: [],
      isAlertListDataLoaded: false,
      // errorList: [],
    };
    this.getFullAlertList = this.getFullAlertList.bind(this);
    this.getAlertById = this.getAlertById.bind(this);
    this.redirectToMetricGroupPage = this.redirectToMetricGroupPage.bind(this);
    this.redirectToAlertForm = this.redirectToAlertForm.bind(this);
    this.redirectToDevicePage = this.redirectToDevicePage.bind(this);
  }

  async componentDidMount() {
    await RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/alerts`)
      .then((response) => {
        this.setState({
          isAlertListDataLoaded: true,
          alertList: [...response.alertList],
        });
      })
      .catch(() => {
        // error handling
      });
  }

  getFullAlertList() {
    const { alertList } = this.state;
    return alertList;
  }

  getAlertById(id) {
    const { alertList } = this.state;
    return alertList.find((alert) => alert.id === id);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToAlertForm(channelKeyList) {
    window.location.assign(`${envConfig.raaUrl}/alerts/new/${channelKeyList}`);
  }

  redirectToMetricGroupPage(metricGroup) {
    const { history } = this.props;
    history.push(`/s/sensor-data/groups/${metricGroup.id}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToAlertDetails(alertId) {
    window.location.assign(`${envConfig.raaUrl}/s/alerts/${alertId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToDevicePage(deviceData) {
    let path;
    switch (deviceData.type) {
      case 'CONNECT':
        path = `/links/${deviceData.id}`;
        break;
      default:
        path = `/s/devices/${deviceData.id}`;
    }
    window.location.assign(`${envConfig.raaUrl}${path}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToUpgradeAccount() {
    window.location.assign(`${envConfig.raaUrl}/s/subscription/billing/change-plan`);
  }

  // eslint-disable-next-line class-methods-use-this
  renderLoadingSpinner() {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div>
          <ProgressSpinner progressText="" />
        </div>
      </div>
    );
  }

  /* istanbul ignore next */
  render() {
    const {
      sessionInformation,
      activeSubscriptionCounts,
      toastNotificationContext,
      activeAlertEventList,
      activeAlertEventListForId,
      thresholdRangeContext,
      preSelectedChannelKey,
      dispatch,
      deviceList,
      metricsGroupContext,
    } = this.props;
    const { isAlertListDataLoaded } = this.state;
    const { reportCount, reportLimit } = activeSubscriptionCounts;
    const { activeSubscription, airSpeedScale } = sessionInformation;
    const additionalHeaderContent = (
      <MaxReportsBanner
        reportCount={reportCount}
        reportLimit={reportLimit}
      />
    );

    if (!isAlertListDataLoaded) {
      return this.renderLoadingSpinner();
    }

    const metricsGroupContextRedux = {
      ...metricsGroupContext,
      ...getMetricsGroupContextRedux(dispatch),
      findById: (mId) => selectMetricGroupById(store.getState(), mId),
      findAll: () => selectAllMetricsGroups(store.getState()),
    };

    return (
      <ExploreMetricsPage
        applicationCode={AvtechApplicationCodes.RAA}
        temperatureScale={sessionInformation.temperatureScale}
        channelsApiUrl={`${envConfig.apiUrl}/api/v1/device-data/channels/fetch-all?auth_token=${sessionHash}`}
        csvReportUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/csv/find-by-channel-keys`}
        reportDataUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`}
        latestSamplesApiUrl={`${envConfig.apiUrl}/api/v1/device-data/latest-samples?auth_token=${sessionHash}`}
        getAnalogComputedUnit={
          (thresholdData) => getAnalogComputedUnit(thresholdData, deviceList.getSensorMap())
        }
        remoteService={RaaAuthenticatedRemoteService.globalInstance()}
        metricsGroupContext={metricsGroupContextRedux}
        pushSessionMessage={(level, title, body, durationInMillis = 5000) => dispatch(
          toastNotificationContext.pushSessionMessage(
            {
              level, title, body, durationInMillis,
            },
          ),
        )}
        masterDeviceList={deviceList}
        userHasActionPrivileges={sessionUserHasRolePrivileges(activeSubscription,
          [RaaRoles.ADMIN, RaaRoles.MANAGER])}
        userJwt={`${sessionHash}`}
        getFullAlertList={this.getFullAlertList}
        getActiveAlertEventList={() => activeAlertEventList}
        getAlertById={this.getAlertById}
        getActiveAlertEventsForAlertId={(alertId) => activeAlertEventListForId(alertId)}
        timeZoneName={sessionInformation.timezone}
        redirectToAlertForm={this.redirectToAlertForm}
        redirectToMetricGroupPage={this.redirectToMetricGroupPage}
        redirectToAlertDetails={this.redirectToAlertDetails}
        redirectToDevicePage={this.redirectToDevicePage}
        additionalHeaderContent={additionalHeaderContent}
        thresholdRangeContext={thresholdRangeContext}
        enableThresholdRanges
        dataLimitUnit={activeSubscriptionCounts.dataAgeLimitUnit}
        dataLimitValue={activeSubscriptionCounts.dataAgeLimitValue}
        onUpgradeClick={this.redirectToUpgradeAccount}
        enableDataLimit
        preSelectedChannelKey={preSelectedChannelKey}
        hasEditPrivileges={
          sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN, RaaRoles.MANAGER])
        }
        userHasAdminPrivileges={
          sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN])
        }
        airSpeedScale={airSpeedScale}
      />
    );
  }
}
ExploreMetricsPageConnected.defaultProps = {
  preSelectedChannelKey: '',
};

ExploreMetricsPageConnected.propTypes = {
  metricsGroupContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  toastNotificationContext: PropTypes.shape({
    dismissMessage: PropTypes.func.isRequired,
    dismissAllMessages: PropTypes.func.isRequired,
    pushSessionMessage: PropTypes.func.isRequired,
  }).isRequired,
  thresholdRangeContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  activeAlertEventList: PropTypes.arrayOf(
    PropTypes.shape({ alertId: PropTypes.string.isRequired }),
  ).isRequired,
  activeAlertEventListForId: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  preSelectedChannelKey: PropTypes.string,
  sessionInformation: sessionInformationPropType.isRequired,
  activeSubscriptionCounts: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  deviceList: deviceListContextPropType.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  activeSubscriptionCounts: selectActiveSubscriptionCounts(state),
  thresholdRangeContext: {
    findAll: () => selectAllThresholdRanges(state),
    findById: (id) => selectThresholdRangeById(state, id),
  },
  toastNotificationContext: {
    getAllMessages: () => selectAllToastNotifications(state),
    dismissMessage: (id) => dismissMessage(id),
    pushSessionMessage: (message) => pushSessionMessage(message),
    dismissAllMessages: () => dismissAllMessages(),
  },
  activeAlertEventList: selectActiveAlertEventList(state),
  activeAlertEventListForId: (alertId) => selectActiveAlertEventsForAlertId(state, alertId),
  deviceList: {
    deviceList: selectRoomAlertDeviceList(state),
    findAll: () => selectRoomAlertDeviceList(state),
    refresh: () => fetchDeviceListData(),
    findByUUID: (uuid) => selectByUuidOrMacAddress(state, uuid),
    getFullDeviceList: () => selectRoomAlertDeviceList(state),
    getSensorMap: () => selectSensorMap(state),
  },
  metricsGroupContext: {
    findById: () => {},
    findAll: () => {},
  },
});
export { ExploreMetricsPageConnected };

export default withRouter(
  connect(mapStateToProps)(ExploreMetricsPageConnected),
);
